import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchBanner } from '../../actions';
import { dataBaseUrl } from '../../../ui/src/utilities';
import './banner.css';

class Banner extends PureComponent {
  constructor(props) {
    super(props);

    this.handleBannerClick = this.handleBannerClick.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(fetchBanner(this.props.id));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.autoReload) {
      if (this.props.location.pathname !== nextProps.location.pathname) {
        this.props.dispatch(fetchBanner(this.props.id));
      }
    }
    if (this.props.banner.uri !== nextProps.banner.uri) {
      let hasBanners = false;
      if (nextProps.banner.uri && nextProps.banner.target) {
        hasBanners = true;
      }
      this.props.hasBanners(hasBanners);
    }
  }

  handleBannerClick() {
    const { name, target } = this.props.banner;

    const label = name.length !== 0 ? name : target;

    if (window && window.ga) {
      window.ga('send', 'event', {
        eventCategory: 'Banner',
        eventAction: `${window.location.href}-${this.props.id}`,
        eventLabel: label,
        eventValue: 1,
      });
    }
  }

  render() {
    if (this.props.banner.uri && this.props.banner.target) {
      return (
        <a
          href={
            this.props.banner.target.match(/(^https?:\/\/)/)
              ? this.props.banner.target
              : `http://${this.props.banner.target}`
          }
          target="_blank"
          onClick={this.handleBannerClick}
        >
          <img
            className="siteBanner"
            src={`${dataBaseUrl()}/${this.props.banner.uri}`}
            alt=""
          />
        </a>
      );
    }
    return <div className="banner" />;
  }
}

Banner.defaultProps = {
  hasBanners: () => {},
  banner: {},
  autoReload: false,
};

Banner.propTypes = {
  id: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  banner: PropTypes.shape({
    uri: PropTypes.string,
    target: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  hasBanners: PropTypes.func,
  autoReload: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, props) => {
  return {
    banner: state.siteBanners.data[props.id]
      ? state.siteBanners.data[props.id].data
      : {},
  };
};

export default connect(mapStateToProps)(Banner);



// WEBPACK FOOTER //
// ./src/app/component/banner/index.js